import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { InvoiceState } from '../graphQL/types';

const Container = styled.div<{ color: string; background: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 4px 8px;

  border-radius: 6px;
  background: ${props => props.background};
  color: ${props => props.color};

  font-family: Pretendard;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.2px;
`;

interface SettlementBadgeIProps {
  status: InvoiceState | null;
}

const SettlementBadge: React.FC<SettlementBadgeIProps> = props => {
  const { status } = props;

  const [badgeInformation, setBadgeInformation] = useState<{
    text: string;
    color: string;
    background: string;
  }>({ text: '', color: '', background: '' });

  const handleSetColor = () => {
    switch (status) {
      case InvoiceState.CANCELLED: {
        return setBadgeInformation({
          text: '지급 취소',
          color: '#70737C',
          background: '#EAEBEC',
        });
      }
      case InvoiceState.COMPLETED: {
        return setBadgeInformation({
          text: '지급 완료',
          color: '#32A06E',
          background: 'rgba(50, 160, 110, 0.20)',
        });
      }
      case InvoiceState.DRAFT_COMPLETED:
      case InvoiceState.PROGRESSING:
      case InvoiceState.READY: {
        return setBadgeInformation({
          text: '지급 진행 중',
          color: '#0071E9',
          background: '#D5E9FF',
        });
      }
      case InvoiceState.FAILED: {
        return setBadgeInformation({
          text: '지급 실패',
          color: '#E5503C',
          background: 'rgba(229, 80, 60, 0.20)',
        });
      }
      case InvoiceState.RECEIVED: {
        return setBadgeInformation({
          text: '회수 완료',
          color: '#32A06E',
          background: 'rgba(50, 160, 110, 0.20)',
        });
      }
      case InvoiceState.RECEIVE_REQUESTED: {
        return setBadgeInformation({
          text: '회수 요청',
          color: '#F5A623',
          background: 'rgba(245, 166, 35, 0.20)',
        });
      }
      default: {
        return setBadgeInformation({
          text: '미지급',
          color: '#70737C',
          background: '#EAEBEC',
        });
      }
    }
  };

  useEffect(() => {
    handleSetColor();
  }, [status]);

  return (
    <Container
      color={badgeInformation.color}
      background={badgeInformation.background}
    >
      {badgeInformation.text}
    </Container>
  );
};

export default SettlementBadge;
